<template>
  <div class="form-buttons">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormButtons',
}
</script>

<style>
/* is defined in forms.pcss */
</style>
